import React from "react";
import Navbar from "../components/navbar/navbar";
import Project from "../components/project/project";
import Footer from "../components/footer/footer";

const Soilcast: React.FC = () => {


  return (
    <>
      <Navbar/>
      <div className="page-content">
        <Project project="soilcast"/>
      </div>
      <Footer />
    </>
  );
};

export default Soilcast;